import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

export const SkeletonFormLoading = () => {
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingTop: 90,
        }}
      >
        <Box sx={{ width: "45%" }}>
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
        </Box>

        <Box sx={{ width: "45%" }}>
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
          <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />{" "}
        </Box>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "end", mt: 4 }}>
        <Skeleton variant="rect" width={120} height={40} />
      </Box>
    </Box>
  );
};
